/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import Fuse from 'fuse.js';

import { actionTypes } from './actionTypes';

export const InitialState = {
  newlyCreatedTeam: null,
  backdrop: {
    message: '',
    open: false,
  },
  baseTeamsList: [],
  viewList: [],
  deleteVoiceModal: {
    canBeDeleted: false,
    open: false,
    team: {},
  },
  editTeamInfo: null,
  searchTerm: '',
  sortField: 'name',
  sortDirection: 'asc',
  sortType: 'string',
  teamsListIsLoading: true,
};

export const teamsReduxReducer = produce((state = InitialState, action) => {
  switch (action.type) {
    case actionTypes.SET_NEWLY_CREATED_TEAM:
      state.newlyCreatedTeam = action.newlyCreatedTeam;

      return state;
    case actionTypes.SET_BASE_LIST: {
      const teamsList = action.teamsList.map((team) => {
        const newTeam = JSON.parse(JSON.stringify(team));
        if (!newTeam.extension) newTeam.extension = '';
        if (!newTeam.phoneNumber) newTeam.phoneNumber = '';
        return newTeam;
      });

      state.baseTeamsList = teamsList;
      state.viewList = teamsList;

      break;
    }
    case actionTypes.SET_VIEW_LIST:
      state.viewList = action.viewList;

      break;
    case actionTypes.DELETE_TEAM_VOICE: {
      const index = state.viewList.findIndex(({ id }) => id === action.payload);

      state.viewList[index].voiceEnabled = false;
      state.viewList[index].extension = '';
      state.viewList[index].phoneNumber = '';
      delete state.viewList[index].durableCallGroupId;

      break;
    }
    case actionTypes.FILTER_VIEW_LIST:
      state.searchTerm = action.searchTerm;

      if (action.searchTerm) {
        const options = {
          shouldSort: false,
          threshold: 0.25,
          keys: ['name', 'extension', 'phoneNumber'],
        };
        const fuse = new Fuse(state.baseTeamsList, options);

        state.viewList = fuse.search(action.searchTerm);
      } else {
        state.viewList = state.baseTeamsList;
      }

      break;
    case actionTypes.ADD_TEAM_TO_LIST:
      state.baseTeamsList.push(action.teamInfo);
      state.viewList.push(action.teamInfo);

      break;
    case actionTypes.SET_SORT:
      state.sortType = action.sortType;

      if (state.sortField === action.sortField) {
        if (state.sortDirection === 'asc') {
          state.sortDirection = 'desc';
        } else {
          state.sortDirection = 'asc';
        }
      } else {
        state.sortField = action.sortField;
        state.sortDirection = 'asc';
      }

      break;
    case actionTypes.SET_DELETE_VOICE_MODAL:
      state.deleteVoiceModal = { ...state.deleteVoiceModal, ...action.payload };

      break;
    case actionTypes.SET_DELETE_VOICE_MODAL_INFO:
      state.backdrop = { message: '', open: false };
      state.deleteVoiceModal = { ...action.payload, open: true };

      break;
    case actionTypes.SET_EDIT_TEAM_INFO:
      state.editTeamInfo = action.editTeamInfo;

      break;
    case actionTypes.UPDATE_TEAM:
      // eslint-disable-next-line no-case-declarations
      const updatedTeamIndex = state.viewList.findIndex((team) => {
        return team.id === action.id;
      });

      if (updatedTeamIndex !== -1) {
        state.viewList[updatedTeamIndex] = {
          ...state.viewList[updatedTeamIndex],
          ...action.teamInfo,
        };
      }

      // eslint-disable-next-line no-case-declarations
      const updatedBaseTeamIndex = state.baseTeamsList.findIndex((team) => {
        return team.id === action.id;
      });

      state.baseTeamsList[updatedBaseTeamIndex] = {
        ...state.baseTeamsList[updatedBaseTeamIndex],
        ...action.teamInfo,
      };

      break;
    case actionTypes.SET_TEAMS_LIST_IS_LOADING:
      state.teamsListIsLoading = action.teamsListIsLoading;

      break;

    case actionTypes.SET_BACKDROP:
      state.backdrop = { ...state.backdrop, ...action.payload };

      break;
    default:
      return state;
  }
});
